var _defs, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedaxion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 521 521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_32);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_32",
    x1: 84.78,
    y1: 564.86,
    x2: 436.22,
    y2: -43.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f65b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74acd9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R - 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 521,
    height: 521,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.17,86.51h47a1.61,1.61,0,0,1,1.61,1.61V393.24a1.61,1.61,0,0,1-1.61,1.61H149.05a1.49,1.49,0,0,1-1.49-1.49V88.12a1.61,1.61,0,0,1,1.61-1.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M575.38,547.15,553,569.49l-22.38-22.34a2,2,0,0,1,1.39-3.38H574A2,2,0,0,1,575.38,547.15Z",
    transform: "translate(-380.34 -135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M795.05,528.41,752.57,463.5q-9.8-14.89-20.08-23.35a59.15,59.15,0,0,0-23.78-11.63q39.66-7,61.38-31.54t21.69-62.77q0-47.11-29.14-72.14t-85.21-25H509.93q-13.53,0-21.22,7.45c-5.14,5-7.71,12-7.71,21v5.88a12.36,12.36,0,0,0,12.37,12.33H531.8l58.81.05H669q34.05,0,50,12.37t15.85,39.42q0,26.59-15.85,39.47t-50,12.81H590.61l.48,46.22h45.74c11.19,0,20.3,2,27.27,6s13.63,11.07,19.86,21L746,555.46a30.61,30.61,0,0,0,25.66,14,31.43,31.43,0,0,0,20.34-7,21.89,21.89,0,0,0,8.63-17.73Q800.67,536.77,795.05,528.41Z",
    transform: "translate(-380.34 -135)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedaxion);
export default __webpack_public_path__ + "static/media/redaxion.1e8719cd9cd636a3e81b3d27c76bbc94.svg";
export { ForwardRef as ReactComponent };